// NOTE: I don't have time to make a legitimate component for this,
// so we will just make a one-off utility....
const simpleCheckboxRowHtml = require("../../sharedHtml/simpleCheckboxRow.html");
import _ from "underscore";
import $ from "jquery";
import {isPresent} from "../general";
import {combineElements} from "../selectorHelpers";
import render from "../render";

const checkboxRowSelectedClass = "additional-filter-selected";

export function bindCheckboxRowItems({namespace, selector}={}){
  const DEFAULT_CHECKBOX_ROW_SELECTOR = `#${namespace}additional-filter-modal .filter-list a`;
  selector = selector || DEFAULT_CHECKBOX_ROW_SELECTOR;
  $(document).on("click", selector, handleCheckboxRowClick);
}

function handleCheckboxRowClick(e){
  const checkboxClicked = e.target.type === 'checkbox';
  if(!checkboxClicked){
    e.preventDefault();
  }
  handleSelectingItem($(this), checkboxClicked);
}



function handleSelectingItem(el, checkboxClicked){
  const checkbox =el.find(":checkbox");
  const isChecked = checkbox.is(':checked');
  if(checkboxClicked){
    // if the checkbox was clicked, we should force
    // the checkbox and highlighting class 
    // into the target state that it is currently in,
    // NOT toggle, because the checkbox handled 
    // 'checking' itself
    toggleCheckboxRowViaBool(el, checkbox, isChecked);
  }
  else{
    // if it was the row that was clicked,
    // we do want to handle toggling both the row class
    // AND the checkbox
    toggleCheckboxRowViaBool(el, checkbox, !isChecked);
  }
};

function toggleCheckboxRowViaBool(el, checkbox, bool){
  checkbox.prop('checked', bool);
  const func = bool ? 'addClass' : 'removeClass';
  el[func](checkboxRowSelectedClass);
}


export function addSimpleCheckboxRows(el, list){
  el.append(renderSimpleCheckboxRows(list));
}

function renderSimpleCheckboxRows(list){
  if(!_.isArray(list)){
    list = [list];
  }
  let ElArray = _(list).map(renderSimpleCheckboxRow);
  ElArray = combineElements(ElArray);
  return ElArray;
}

function renderSimpleCheckboxRow(data){
  data.isPresent = isPresent;
  return $(render(simpleCheckboxRowHtml, data));
}


// WEBPACK FOOTER //
// ./src/utilities/additionalFilterLogic/index.js